export interface BananaTypeProps {
  key: string;
  img: string;
  title: string;
  description: string;
}

export interface SeasonalBananaTypeProps extends BananaTypeProps {
  startMonthDay: string;
  endMonthDay: string;
}

export class BananaType {
  
  public static bananaCollectionEveryday: BananaTypeProps[] = [
    { key: "you-got-this", img: "/logos/bananas/you-got-this-1.png", title: "You've Got This", description: "“This banana believes in you. So do I.”" },
    { key: "wink", img: "/logos/bananas/wink-1.png", title: "A Little Wink 😉", description: "“This banana knows….😉”" },
    { key: "thank-you", img: "/logos/bananas/thank-you-1.png", title: "Thank You", description: "“This banana says what I'm thinking: Thank you!”" },
    { key: "congratulations", img: "/logos/bananas/congratulations-1.png", title: "Congratulations", description: "“This banana is bursting with joy for you - well done!”" },
    { key: "hello-to-my-little-banana", img: "/logos/bananas/you-got-this-1.png", title: "Say hello to my little banana!", description: "“Spread the joy.  Banana it forward!”" },
    { key: "love-you", img: "/logos/bananas/love-you-1.png", title: "I Love You", description: "“A sweet reminder - you're loved. By me and this banana.”" },
  ];

  public static bananaCollectionCelebration: BananaTypeProps[] = [
    { key: "happy-birthday", img: "/logos/bananas/happy-birthday-1.png", title: "Happy Birthday", description: "“Another trip around the sun - this banana's here to celebrate you!”" },
    { key: "happy-anniversary", img: "/logos/bananas/happy-anniversary-1.png", title: "Happy Anniversary", description: "“Another year, another reason to love bananas… and you two.”" },
    { key: "welcome-baby", img: "/logos/bananas/welcome-baby-1.png", title: "Welcome Baby", description: "“Welcome to the world, little one - your first banana is on me.”" },
    { key: "congrats-graduate", img: "/logos/bananas/congrats-graduate-1.png", title: "Happy Graduation", description: "“You did it! This banana is wearing its cap just for you.”" },
  ];

  public static bananaCollectionCareAndComfort: BananaTypeProps[] = [
    { key: "get-well-soon", img: "/logos/bananas/get-well-soon-1.png", title: "Get Well Soon", description: "“A little banana sunshine to help you feel better.”" },
    { key: "thinking-of-you", img: "/logos/bananas/thinking-of-you-1.png", title: "Thinking of You", description: "“Sometimes all you need is a banana… and someone thinking of you.”" },
  ];

  public static bananaCollectionSeasonal: SeasonalBananaTypeProps[] = [
    { key: "youre-the-zest", img: "/logos/bananas/seasonal-valentine.png", title: "Happy Valentine's Day", description: "“No tricks, just true feelings — Happy Valentine's.”", startMonthDay: "02-01", endMonthDay: "02-14" },
    { key: "new-year-new-peel", img: "/logos/bananas/seasonal-school.png", title: "Back to School", description: "“First-day jitters? This banana's got your back.”", startMonthDay: "08-01", endMonthDay: "09-15" },
    { key: "boo-nana", img: "/logos/bananas/seasonal-halloween.png", title: "Happy Halloween", description: "“No tricks, just a treat for you.”", startMonthDay: "10-01", endMonthDay: "10-31" },
    { key: "grateful-bunch", img: "/logos/bananas/seasonal-thanksgiving.png", title: "Happy Thanksgiving", description: "“This banana's thankful for you.”", startMonthDay: "11-01", endMonthDay: "11-30" },
    { key: "seasons-peelings", img: "/logos/bananas/seasonal-holidays.png", title: "Happy Holidays", description: "“Wrapping up the year with a little joy for you.”", startMonthDay: "12-01", endMonthDay: "12-31" },
  ];

  // Retired from the chooser, but retained so historical bananas and links render normally.
  private static retiredTypes: BananaTypeProps[] = [
    { key: "welcome-to-the-bananaverse", img: "/logos/bananas/you-got-this-1.png", title: "Welcome to the Bananaverse!", description: "“It only takes one banana to start spreading joy. Banana it forward!”" },
    { key: "to-happy-couple", img: "/logos/bananas/to-happy-couple-1.png", title: "To The Happy Couple!", description: "“A perfect pair deserves the perfect banana. Cheers to you both!”" },
    { key: "bunches-of-thanks", img: "/logos/bananas/seasonal-appreciation.png", title: "Bunches of Thanks!", description: "“This banana clocked in just to say: you're appreciated.”" },
  ];

  public static getFeaturedSeasonal = (date = new Date()): SeasonalBananaTypeProps | undefined => {
    const monthDay = `${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
    return BananaType.bananaCollectionSeasonal.find(({ startMonthDay, endMonthDay }) => monthDay >= startMonthDay && monthDay <= endMonthDay);
  };

  public static allTypes: BananaTypeProps[] = [
    ...BananaType.bananaCollectionEveryday,
    ...BananaType.bananaCollectionCelebration,
    ...BananaType.bananaCollectionCareAndComfort,
    ...BananaType.bananaCollectionSeasonal,
    ...BananaType.retiredTypes,
  ]

  public static getBananaTypeByKey = (key: string): BananaTypeProps | undefined => {
    return BananaType.allTypes.find(banana => banana.key === key);
  }
}
